// React Dependencies
import React, { useEffect } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import moment from 'moment';

// Internal Dependencies
import Header from './Header';
import Main from './Main';
import Preview from './Preview/Preview';
import withLoyaltyConnect from './WithLoyaltyConnect';
import { LoyaltyHeaderMenu } from '../../../../common/constants';
import ApiService from '../../../../services/apiService';
import { IsEmpty } from '../../../../common/checks';
import { AvailableImages, DesignTypeOptions } from './constants';

const TabsToHidePreview = [
  LoyaltyHeaderMenu.Receipt,
  LoyaltyHeaderMenu.Status,
  LoyaltyHeaderMenu.Outlets,
];

const LoyaltyCard = (props) => {
  const fetchLoyaltyCardAndLinkedGifts = async () => {
    try {
      const result = await ApiService.getLoyaltyCardWithLinkedGifts(props.page.id, props.match.params.loyaltyCardId);
      const { mainImage, design: designImage } = result;

      const selectedDesign = AvailableImages.find((tmp) => tmp.image === designImage);

      const isUsingUploadedDesign = !IsEmpty(mainImage);

      const design = {
        designType:                   isUsingUploadedDesign ? DesignTypeOptions.Manual : DesignTypeOptions.Template,
        uploadedDesign:               isUsingUploadedDesign ? mainImage : null,
        stampsHolderBackgroundColour: isUsingUploadedDesign ? result.bkgrdColour : null,
        selectedLoyaltyCardTemplate:  selectedDesign?.top || AvailableImages[0].top,
        selectedStampsHolderTemplate: selectedDesign?.btm || AvailableImages[0].btm,
        templatePreview:              selectedDesign?.image || AvailableImages[0].image,
      };

      props.updateLoyaltyCardAction({
        id:               result.id,
        pageId:           result.pageId,
        name:             result.name,
        expiryDate:       result.expiryDate,
        validityInMonths: result.validityInMonths,
        image:            isUsingUploadedDesign ? mainImage : null,
        stamp:            {
          numOfStamps:      result.numOfStamps || 10,
          amountPerStamp:   result.amountPerStamp || 1,
          redeemStampImage: result.redeemStampImage,
        },
        vouchers: result.gifts.map((gift) => ({
          ...gift,
          minSpend:   gift.minSpend === 0 ? null : gift.minSpend,
          expiryDate: !IsEmpty(gift.expiryDate) ? moment(gift.expiryDate).utcOffset('+08').format('YYYY-MM-DD') : null,
        })),
        status:               result.status,
        design,
        additionalTnC:        result.additionalTnc,
        pauseVoucherIssuance: result.gifts.length === 0
          ? false
          : result.gifts[0].pauseIssuance || false, // in case the pauseIssuance value is null, we set the default value as false
      });
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchLoyaltyCardAndLinkedGifts();
  }, []);

  return (
    <div
      className="container-fluid"
    >
      <div className="row">
        <div className="col-12">
          <Header />
        </div>
      </div>
      <div className="row">
        <div className={`col-12 ${TabsToHidePreview.includes(props.tab) ? 'col-12' : 'col-lg-8'}`}>
          <Main match={props.match} />
        </div>
        <div className={`${TabsToHidePreview.includes(props.tab) ? 'd-none' : 'd-none d-lg-block col-lg-4'}`}>
          <Preview />
        </div>
      </div>
    </div>
  );
};
LoyaltyCard.propTypes = {
  tab:  PropTypes.arrayOf(PropTypes.string).isRequired,
  page: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      loyaltyCardId: PropTypes.string,
    }),
  }).isRequired,

  updateLoyaltyCardAction: PropTypes.func.isRequired,
};

export default withLoyaltyConnect(LoyaltyCard);
